
    <div class="row" [hidden]="msgHead.msg == ''">
      <div class="col-lg-8 col-md-6 col-xs-12">
          <alert [alert]="msgHead"></alert>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
        <div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px; margin-bottom:0px;">
            <form [formGroup]="form" novalid>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-xs-12" style="margin-bottom: 0px;">
                        <div class="form-group">
                            <p class="custom-label">Label - Used for display purpose only</p>
                            <input type="text" [(ngModel)]="data.label" formControlName="label" class="form-control" placeholder="Label" title="Label">
                        </div>

                        <div class="form-group">
                            <p class="custom-label">Name - Actual Attribute Name in SAML Response</p>
                            <input type="text" [(ngModel)]="data.name" formControlName="name" class="form-control" placeholder="Name" title="Name">
                        </div>

                        <div class="form-group">
                            <p class="custom-label">User Attribute Mapping</p>
                            <select [(ngModel)]="data.userAttributeMapping" formControlName="userAttributeMapping" class="form-control" title="User Attribute Mapping">
                                <option *ngFor="let uam of userAttributeMappingList; let i = index" [value]="uam.id">{{uam.title}}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label class="custom-label">Skip If Blank</label><br/>
                            <app-toggle [(toggle)]="data.skipIfBlank"></app-toggle>
                        </div>

                        <div class="form-group">
                            <a style="cursor:pointer;" (click)="switchAdvancedSettings()">{{ showAdvancedSettings ? 'Hide' : 'Show' }} Advanced Settings</a>
                        </div>

                        <div *ngIf="showAdvancedSettings">
                            <div class="form-group">
                                <label class="custom-label">Default Values - When values are empty in SAML Response then this will be used instead</label>
                                <textarea style="width:auto;" class="form-control" [(ngModel)]="data.defaultValues" formControlName="defaultValues" placeholder="Default Values" title="Default Values" rows="4" cols="80"></textarea>
                            </div>

                            <div class="form-group">
                                <label class="custom-label">Instead Values - If typed then this will replace the actual values from SAML response</label>
                                <textarea style="width:auto;" class="form-control" [(ngModel)]="data.values" formControlName="values" placeholder="Instead Values" title="Instead Values" rows="4" cols="80"></textarea>
                            </div>

                            <div class="form-group">
                                <p class="custom-label">Attribute Validations Regex</p>
                                <input type="text" [(ngModel)]="data.attributeValidationsRegex" formControlName="attributeValidationsRegex" class="form-control" placeholder="Attribute Validations Regex" title="Attribute Validation Regex">
                            </div>

                            <div class="form-group">
                                <p class="custom-label">Attribute Transformations Regex</p>
                                <input type="text" [(ngModel)]="data.attributeTransformationsRegex" formControlName="attributeTransformationsRegex" class="form-control" placeholder="Attribute Transformations Regex" title="Attribute Transformations Regex">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-lg-12 col-md-12 col-xs-12" style="margin-top:0px;">
            <button type="button" class="btn btn-large btn-primary" (click)="save()">Save</button>
            <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
        </div>
    </div>
    <div *ngIf="hasAccess" class="row">
        <div class="col-lg-6 col-md-6 col-xs-12">
            <alert [alert]="msg" style="display:block;"></alert>
        </div>
    </div>
  